import img5 from "../../assets/5.png";
import img6 from "../../assets/6.png";
import img3 from "../../assets/4.jpg";
import img9 from "../../assets/9.png";
import img10 from "../../assets/10.png";
import img11 from "../../assets/11.png";

const projectCardData = [
{
    imgsrc : img5 ,
    title :"Admin Dashboard",
    text :"this is a websites based on react html css and it is showing only admin admin dashboard.",
    view:"www.google.com",
 

},
{
    imgsrc : img6 ,
    title :"Hpad",
    text :"this is a software that is works as the notepad with some external and advance feature.",
    view:"https://github.com/hritik8795/Hpad",
    

},


{
    imgsrc : img3 ,
    title :"Admin Dashboard",
    text :"this is a websites based on react html css and it is showing only admin admin dashboard.",
    view:"https://solemndashboard.netlify.app/",
    

},
{
    imgsrc :img9 ,
    title :"User Authentication",
    text :"this is a user authentication website by using mongo db react express node .",
    view:"https://github.com/hritik8795/mern-auth",
    

},
{
    imgsrc : img10 ,
    title :"Github profile",
    text :"this is not a project it is a github profile",
    view:"https://github.com/hritik8795",
    

},
{
imgsrc : img11 ,
    title :"frontend",
    text :"this is a front end web page",
    view:"https://github.com/hritik8795/Web-development",
}
] 
export default projectCardData 